import { useState } from 'react'
import type { ChatMessageDto } from '@lunary/api-client'
import { useSaveChatExample } from './queries'
import styles from './studio.module.css'

const RATINGS = [1, 2, 3, 4, 5] as const

export type MilaTurn = { content: string; original: string; model: string; promptVersion: string; saved: boolean }

type Props = {
  readonly turn: MilaTurn
  readonly history: readonly ChatMessageDto[]
  readonly onSaved: (content: string) => void
}

export function ChatReply({ turn, history, onSaved }: Props) {
  const [editing, setEditing] = useState(false)
  const [text, setText] = useState(turn.content)
  const [rating, setRating] = useState(0)
  const [comment, setComment] = useState('')
  const save = useSaveChatExample()

  if (!editing) {
    return (
      <div className={`${styles.bubble} ${styles.bubbleMila}`}>
        <div className={styles.bubbleText}>{turn.content}</div>
        <div className={styles.bubbleMeta}>
          <span>
            Мила · {turn.model} · {turn.promptVersion}
          </span>
          {turn.saved ? (
            <span className="badge ok">эталон</span>
          ) : (
            <button className="secondary" onClick={() => setEditing(true)}>
              Поправить и сохранить
            </button>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={`${styles.bubble} ${styles.bubbleMila}`}>
      <textarea rows={6} value={text} aria-label="Ответ Милы" onChange={(e) => setText(e.target.value)} />
      <div className={styles.rating} role="radiogroup" aria-label="Оценка ответа модели">
        <span className="muted">Оценка модели</span>
        {RATINGS.map((r) => (
          <button
            key={r}
            role="radio"
            aria-checked={rating === r}
            className={rating === r ? 'active' : 'secondary'}
            onClick={() => setRating(r)}
          >
            {r}
          </button>
        ))}
      </div>
      <textarea
        rows={2}
        value={comment}
        maxLength={2000}
        placeholder="Комментарий: что поправили"
        aria-label="Комментарий"
        onChange={(e) => setComment(e.target.value)}
      />
      <div className="row">
        <button
          className="ok"
          disabled={save.isPending || rating === 0 || text.trim().length < 10}
          onClick={() =>
            save.mutate(
              {
                messages: [...history],
                model_output: turn.original,
                expert_output: text,
                rating,
                comment,
                model: turn.model,
                prompt_version: turn.promptVersion,
              },
              { onSuccess: () => onSaved(text.trim()) },
            )
          }
        >
          {save.isPending ? 'Сохраняю…' : 'Сохранить как эталон'}
        </button>
        <button className="secondary" onClick={() => setEditing(false)}>
          Отмена
        </button>
      </div>
      {save.error && <p className="error-box">{save.error instanceof Error ? save.error.message : 'Не удалось сохранить'}</p>}
    </div>
  )
}
